/*======================================================
To-do: Refactor this to be part of SocialPostSmallCard.js (low priority - code organization)
2026-09-21: Is used for jobs and talents to be displayed in social feed. 
=======================================================*/

"use client"
import Alert from "@/components/Atoms/Alerts/Alert";
import { ArrowUpButton, CommentButton, ConfirmOrCancelButton, CopyUrlButton, IndigoButton, MultipurposeOvalButton, OpenUrlButton, TealButton, TrashButton } from "@/components/Atoms/Buttons/ColorButtons";
import ReactMarkdownMod from "@/components/Atoms/ReactMarkdownMod";
import TagPill_1 from "@/components/Atoms/Tags/TagPill_1";
import AvatarImage from "@/components/Molecules/AvatarImage";
import { dateFormat_2, dateFormat_3 } from "@/utils/frontend/dateOps";
import getTagDevIconName from "@/utils/frontend/getTagDevIconName";
import { formatSocialPostBody, formatString, getEntityLocationStr, humanizeString } from "@/utils/frontend/stringOps";
import Link from "next/link";
import { useState } from "react";
import ReactMarkdown from 'react-markdown';
import { useRouter, useSearchParams } from 'next/navigation'
import BorderedFrameBox from "@/components/Molecules/BorderedFrameBox";
import TagPill_3 from "@/components/Atoms/Tags/TagPill_3";
import ReactMarkdownMod_2 from "@/components/Atoms/ReactMarkdownMod_2";

const SocialAssetSmallCard = ({ 
  data, 
  callback, 
  state, 
  lang, 
  user, 
  parentComponent, // INDEX, THREAD, PAGE (social/[post]/page.js)
  parentModule, // JOBS, TALENTS
  isNestedComment, 
  replyToUUID,
  cardIsClickable=true,
 }) => {

  // console.log("DATA@SocialAssetSmallCard", data)
  const cardIsComment = Boolean(data.social_post_comment_uuid)

  //   console.log("USER@SocialPostSmallCard", user)
  // console.log('data@socialpostsmallcard', data)
// console.log(data.parent_social_post_comment_uuid, data.social_post_comment_body)
  const router = useRouter()
  const searchParams = useSearchParams()
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [deleteConfirmation, setDeleteConfirmation] = useState(0)
  const [rootDeleteConfirmation, setRootDeleteConfirmation] = useState(0)

  // console.log("DATA@SocialPostSmallCard.js", data)
  // console.log("DATA@JobBigCard.js", data)
  // let data = selectedData ? selectedData : initialData 



  /*=====================================================
  --- HELPER FUNCTIONS START
  ======================================================*/

  // get normalized module name, record uuid, record url
  const getRecordData = (parentModule) => {

    let moduleName, uuid, url;

    if (parentModule === 'TALENTS') { 
      moduleName = 'talent'
      uuid = data.talent_uuid
      url = data.talent_url
    }
    else if (parentModule === 'JOBS') {
      moduleName = 'jobs'
      uuid = data.job_uuid
      url = data.job_url
    }

    return {module:moduleName, uuid:uuid, url:url};
    
  }


  const renderData = () => {

  let firstName =data.user_data.user_first_name
  let lastName = data.user_data.user_last_name


  let fullName, handle, postBody, postTitle;

  if (data.is_anonymous === true) {
    fullName = 'Anonymous'
    handle = null
    postBody = data.social_post_body || data.social_post_comment_body
    postTitle = data.social_post_title
  }

  else if (data.job_status === 'ACTIVE' || data.talent_status === 'ACTIVE') {
  fullName = firstName + (lastName ? ' ' + lastName : '')
    handle = data.user_data.user_handle
    postBody = data.job_description?.['en'] || data.talent_resume?.['en']
    postTitle = data.job_title?.['en'] || data.talent_job_title?.['en']
  }
  else if (data.job_status === 'ARCHIVED' || data.talent_status === 'ARCHIVED') {
    fullName = 'Deleted'
    handle = 'Deleted'
    postBody = '[ Deleted ]'
    postTitle = 'Deleted'
  }
  else if (data.job_status === 'PENDING_REVIEW' || data.talent_status === 'PENDING_REVIEW'){
    if (user?.user_roles?.role === 'ROOT' || user?.user_roles?.role === 'MODERATOR'){
    fullName = firstName + (lastName ? ' ' + lastName : '') + ' '
    handle = data.user_data.user_handle
    postBody = "** PENDING_REVIEW **\n(only you can see this)\n\n" + (data.job_description?.['en'] || data.talent_resume?.['en'])
   postTitle = data.job_title?.['en'] || data.talent_job_title?.['en']
    }
    else {
      return null;
    }
  }
  
  const postBodyAbbreviated = postBody?.length > 500 ? postBody.substring(0,500) + '...' : postBody
  return {fullName: fullName, handle: handle, postBody: {abbreviated: postBodyAbbreviated, full: postBody}, postTitle: postTitle}
  }

  /*=====================================================
  --- HELPER FUNCTIONS END
  ======================================================*/



  /*=====================================================
  --- ACTION FUNCTIONS START
  ======================================================*/

  //callback from TasksSplitViewCard.js 
  // handleSubmit from Task Status Button
  const handleChildCallback= async (cback)=> {
      
  }   

  // console.log("DATA@JobBigCard", data)

  const handleEditSubmit = (element) =>{

      const putData = {
          id: data?.task_data.id,
          task_title: editedData?.task_title || data?.task_data.task_title,
          task_type: editedData?.task_type || data?.task_data.task_type,
          task_due_date: editedData?.task_due_date || data?.task_data.task_due_date,
          task_content: editedData?.task_content || data?.task_data.task_content,
          task_status: editedData?.task_status || data?.task_data.task_status
      }

    
      callback({action: 'taskUpdate', putData: putData})
  }


  const handleDelete = async (e) => {
      e.stopPropagation()
    if (deleteConfirmation === 0) {
      setDeleteConfirmation(1)
      return false;
    }
    try {
    //    ?id=${target.id}
    let apiUrl;
    if (parentComponent === 'THREAD') { // in post thread - deleting comment
      apiUrl = `/api/social/comments/${data.social_post_comment_uuid}?user_type=${user.user_type}`
    }
    else { // in all posts (social) - deleting post
      apiUrl = `/api/social/posts/${data.social_post_uuid}?user_type=${user.user_type}`
    }

          let response = await fetch(apiUrl, {
          method: 'PUT', // if deleting comment, PUT, if deleting post, PUT as well
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          },
          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
            body: JSON.stringify({data: {
            status: 'ARCHIVED',
            notification_recipient_user_uuid: data.social_post_user_uuid ? data.social_post_user_uuid : data.social_post_comment_user_uuid // either comment's or post's owner uuid, depending on what we're liking
          }, user: user})
          // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
          // body: data
        });

        response = await response.json()
        console.log('handleDeleteResponse', response)
      if (response.success === true ) {
        setSuccess({message: 'The post has been deleted.'})
        router.refresh()
    //    setLoading(false)
      }
      else { 
        setError({message: 'There was a problem deleting this post.'})
    //    setLoading(false)
      }
      // callback({refreshData: true})

            
        } catch (error) {
          console.log('error', error)
          // setLoading(false)
        }
  }


  const handleRootDelete = async (e) => {

    e.stopPropagation()
    if (rootDeleteConfirmation === 0) {
      setRootDeleteConfirmation(1)
      return false;
    }
    try {
    //    ?id=${target.id}
      let apiUrl;
      apiUrl = `/api/${getRecordData(parentModule).module}/${data.id}?user_type=${user.user_type}`
    


          let response = await fetch(apiUrl, {
          method: 'DELETE', // if deleting comment, PUT, if deleting post, PUT as well
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          },
          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
          // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
          // body: data
        });

        response = await response.json()
        console.log('handleDeleteResponse', response)
      if (response.success === true ) {
        setSuccess({message: 'The job has been deleted.'})
        router.refresh()
    //    setLoading(false)
      }
      else { 
        setError({message: 'There was a problem deleting this job.'})
    //    setLoading(false)
      }
      // callback({refreshData: true})

            
        } catch (error) {
          console.log('error', error)
          // setLoading(false)
        }
  }


  const handleRootStatusChange = async (e, statusArg) => {
    e.stopPropagation()
    // e.preventDefault()

    try {
    //    ?id=${target.id}
    let apiUrl;
    apiUrl = `/api/${getRecordData(parentModule).module}/${getRecordData(parentModule).uuid}?user_type=${user.user_type}`
    


        let response = await fetch(apiUrl, {
        method: 'PUT', // if deleting comment, PUT, if deleting post, PUT as well
        headers: {
          'Accept': '*/*',
          'Content-Type': 'application/json'
        },
        credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
        body: JSON.stringify({data: {
          job_status: statusArg,
          notification_recipient_user_uuid: data.social_post_user_uuid ? data.social_post_user_uuid : data.social_post_comment_user_uuid // either comment's or post's owner uuid, depending on what we're liking
        }, user: user})
        // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
        // body: data
      });

      response = await response.json()
      console.log('handleDeleteResponse', response)
    if (response.success === true ) {
      setSuccess({message: `The status has been changed to ${statusArg}`})
      router.refresh()
    //    setLoading(false)
    }
    else { 
      setError({message: 'There was a problem deleting this post.'})
    //    setLoading(false)
    }
    // callback({refreshData: true})

          
      } catch (error) {
        console.log('error', error)
        // setLoading(false)
      }
  }


  const handlePostUpvote = async (e) => {
    e.stopPropagation()
    if (!user) {
      setError({message: 'Please sign in'})
    }
     try {
     //    ?id=${target.id}
    //  let apiUrl = `/api/social/reactions/${data.social_post_uuid}?user_type=${user.user_type}`
          let apiUrl = `/api/social/reactions?user_type=${user.user_type}`


          let response = await fetch(apiUrl, {
          method: 'POST', // if deleting comment, PUT, if deleting post, PUT as well
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          },
          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
          body: JSON.stringify({data: {
            reaction_type: 'UPVOTE', 
            reaction_target_type: data.social_post_uuid ? 'SOCIAL_POST' : 'SOCIAL_COMMENT',
            reaction_target_uuid: data.social_post_uuid ? data.social_post_uuid : data.social_post_comment_uuid,
            notification_recipient_user_uuid: data.social_post_user_uuid ? data.social_post_user_uuid : data.social_post_comment_user_uuid // either comment's or post's owner uuid, depending on what we're liking
          }, user: user}), // Convert the credentials object to a JSON string
          // body: data
        });

        response = await response.json()
        console.log('handleUpvoteResponse', response)
      if (response.success === true ) {
        // setSuccess({message: 'The post has been upvoted.'})
        router.refresh()
     //    setLoading(false)
      }
      else { 
        setError({message: `There was a problem upvoting this post. Error: ${response.error}`})
     //    setLoading(false)
      }
      // callback({refreshData: true})

            
        } catch (error) {
          console.log('error', error)
          // setLoading(false)
        }
  }


  const handleDeleteUpvote = async (e) => {
    e.stopPropagation()
        try {
      //    ?id=${target.id}
      let apiUrl;
      if (parentComponent === 'THREAD') { // in post thread - deleting comment
        apiUrl = `/api/social/reactions/${data.social_post_comment_uuid}?user_type=${user.user_type}&record_type=COMMENT`
      }
      else { // in all posts (social) - deleting post
        apiUrl = `/api/social/reactions/${data.social_post_uuid}?user_type=${user.user_type}&record_type=POST`
      }

            let response = await fetch(apiUrl, {
            method: 'DELETE', // if deleting comment, PUT, if deleting post, PUT as well
            headers: {
              'Accept': '*/*',
              'Content-Type': 'application/json'
            },
            credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
            // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
            // body: data
          });

          response = await response.json()
          console.log('handleDeleteResponse', response)
        if (response.success === true ) {
          // setSuccess({message: 'The post has been deleted.'})
          router.refresh()
      //    setLoading(false)
        }
        else { 
        setError({message: `There was a problem upvoting this post. Error: ${response.error.message}`})
      //    setLoading(false)
        }
        // callback({refreshData: true})

              
          } catch (error) {
            console.log('error', error)
            // setLoading(false)
          }
  }


  const handleCardClick = async (e) => {

    // if we hit the comment button either on a page or in a thread, it'll focus on text area,
    // if however we hit the comment button in /social/page.js, it won't.
    (parentComponent === 'THREAD' || parentComponent === 'PAGE') && callback({focusOnTextArea: true})
    if (parentComponent === 'THREAD'){ // in root comment thread, this becomes a reply to a comment
        // router.push(`?thread=${searchParams.get('thread')}&reply-to-uuid=${data.social_post_comment_uuid}&reply-to-handle=${data.user_data.user_handle}`, undefined, {shallow:true, scroll:false})
        router.push(`/${getRecordData(parentModule).url}/${getRecordData(parentModule).url}`)
    }
    else if (parentComponent === 'PAGE'){ // from /social/[post]/page.js
      //  router.push(`?reply-to-uuid=${data.social_post_comment_uuid}&reply-to-handle=${data.user_data.user_handle}#${data.social_post_comment_uuid}`, undefined, {shallow:true, scroll:false})
      router.push(`/${getRecordData(parentModule).url}/${getRecordData(parentModule).url}`)
    }
    else if (parentComponent === 'INDEX') { // in all posts, this becomes a root comment to a post (we're attaching social/ to searchParams)
      // router.push(`feed?thread=${data.social_post_uuid}`, undefined, {shallow:true, scroll:false})
      router.push(`/${getRecordData(parentModule).url}/${getRecordData(parentModule).url}`)
    }
    // else if (parentComponent === 'PAGE') { // from social/[post]/page.js
    //   router.push(`?reply-to-uuid=${data.social_post_comment_uuid}&reply-to-handle=${data.user_data.user_handle}#${data.social_post_comment_uuid}`, undefined, {shallow:true, scroll:false})
    // }
    else { // in all posts, this becomes a root comment to a post
      // router.push(`?thread=${data.social_post_uuid}#${data.social_post_uuid}`, undefined, {shallow:true, scroll:false})
      router.push(`/${getRecordData(parentModule).module}/${getRecordData(parentModule).url}`)
      // #data.socialpostuuid prevents page from jumping up here
    }
  }


  const handleChange = (field, value) => {
    //    setEditedData({
    //        ...editedData,
    //        [field]: value
    //        // [event.target.name]: event.target.value,
    //    });
    //    console.log(editedData);
  };

  // function countComments(comments = []) {
  //   let count = 0;

  //   for (const comment of comments) {
  //     count += 1; // count this comment

  //     if (comment.replies && comment.replies.length > 0) {
  //       count += countComments(comment.replies); // recurse
  //     }
  //   }

  //   return count;
  // }

  function countComments(comments = []) {
      let count = 0;

      for (const comment of comments) {
          count += 1; // count this comment

          if (comment.replies && comment.replies.length > 0) {
          count += countComments(comment.replies); // recurse
          }
      }

      return count;
  }

  /*=====================================================
  --- ACTION FUNCTIONS END
  ======================================================*/

const rd = renderData()
if (!rd) { return null; }

// console.log("data@SocialPostSmallCard", data)
// console.log("replyToUUID", replyToUUID, data.social_post_comment_uuid, data.social_post_comment_body)

  // if the post doesn't have thE ACTIVE or ARCHIVED status, hide it (example PENDING_REVIEW) and the user isn't root
  return (

    <div onClick={e=>{cardIsClickable === true ? handleCardClick(e) : ()=>{}}} id={data.social_post_uuid || data.social_post_comment_uuid} className={`
      ${(parentComponent === 'THREAD' || parentComponent==='PAGE') ? 'bg-slate-50 dark:bg-slate-900' : 'bg-gray-50 dark:bg-gray-800 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700'} 
      ${isNestedComment && 'border-l'} 
      ${(replyToUUID && replyToUUID === data.social_post_comment_uuid) && 'dark:bg-slate-950 bg-slate-100 border-l-2 border-l-teal-400 dark:border-l-teal-400'} 
      w-full border-b border-slate-200 dark:border-slate-700 px-4 py-6 transition duration-150 text-base font-inter`}>
          <Alert state={{success: success, setSuccess: setSuccess, error: error, setError: setError}} message={success ? success.message : error ? error.message : ''}/>

          {/* Header: Avatar + Name + Timestamp */}
          <div className="flex items-start gap-3">
            {/* avatar */}
            {(data.job_status === 'ACTIVE' || data.talent_status === 'ACTIVE') && data.is_anonymous === false
            ? 
            <Link onClick={e=>e.stopPropagation()} href={`/@${data.user_data.user_handle}`}>
              <AvatarImage isAnonymous={data.is_anonymous} data={data.user_data} module="USER" size={parentComponent==='THREAD' ? 'xs' : 'sm'} hoverable={true} />
            </Link> 
            :
              data.is_anonymous ? 
              <AvatarImage isAnonymous={data.is_anonymous} data={data.user_data} module="USER" size={parentComponent==='THREAD' ? 'xs' : 'sm'} hoverable={true} />
              :
            <AvatarImage isDeleted={(data.job_status === 'ARCHIVED' || data.talent_status === 'ARCHIVED')} data={data.user_data} module="USER" size={parentComponent==='THREAD' ? 'xs' : 'sm'} hoverable={false} />
            }

            {/* name */}
            <div className="flex flex-col w-full">
              <div className="flex items-start gap-2 leading-none">

                  <div className="flex flex-col gap-1">
                    <Link onClick={e=>e.stopPropagation()} href={`/@${renderData().handle}`}>
                    <span className={`hover:underline cursor-pointer dark:text-white font-ubuntu`}>
                      {renderData().fullName}<br/>
                    </span>
                    </Link>
                    <div className="flex flex-row gap-1">
                      <Link onClick={e=>e.stopPropagation()} href={`/@${renderData().handle}`}>
                    <span className="flex items-center text-xs text-slate-400">@{renderData().handle}</span>
                    </Link>
                    <span className="flex items-center text-slate-300  text-xs" aria-hidden="true">⋅</span>
                    <span className="flex items-center text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
                    </div>

                  </div>
                  {/* :
                  data.is_anonymous ?
                  <div className="flex flex-col gap-1">
                    <span className={`dark:text-white font-ubuntu`}>
                    Anonymous
                    </span>
                    <span className="text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
                  </div>
                  :
                  <div className="flex flex-col gap-1">
                  <span className={`dark:text-white font-ubuntu`}>
                  Deleted
                  </span>
                  <span className="text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
                  </div>
                } */}









                {/* {data.job_status === 'ACTIVE' && data.is_anonymous === false
                  ? 
                  <div className="flex flex-col gap-1">
                  <Link onClick={e=>e.stopPropagation()} href={`/@${data.user_data.user_handle}`}>
                    <span className={`hover:underline cursor-pointer dark:text-white font-ubuntu`}>
                      {data.user_data.user_first_name} {data.user_data.user_last_name}<br/>
                    </span>
                    </Link>
                    <div className="flex flex-row gap-1">
                      <Link onClick={e=>e.stopPropagation()} href={`/@${data.user_data.user_handle}`}>
                    <span className="flex items-center text-xs text-slate-400">@{data.user_data.user_handle}</span>
                    </Link>
                    <span className="flex items-center text-slate-300  text-xs" aria-hidden="true">⋅</span>
                    <span className="flex items-center text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
                    </div>

                  </div>
                  :
                  data.is_anonymous ?
                  <div className="flex flex-col gap-1">
                    <span className={`dark:text-white font-ubuntu`}>
                    Anonymous
                    </span>
                    <span className="text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
                  </div>
                  :
                  <div className="flex flex-col gap-1">
                  <span className={`dark:text-white font-ubuntu`}>
                  Deleted
                  </span>
                  <span className="text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
                  </div>
                } */}

              
              </div>
              
              {/* post body + image(s) */}
              <div className="my-2">
                {/* {parentComponent==='THREAD' 
                  ? // if post is timeless, render markdown, else render formatted.
                  formatSocialPostBody(renderData().postBody)
                  : 
                formatSocialPostBody (renderData().postBody)
                } */}

                {/* if it's timeless, render markdown, else, render formatted.
                  if it's in thread or in page, render full, if it's in feed, render abbreviated
                */}

                {1==1 ? 
                <div className="prose prose-lg break-word overflow-x-auto max-w-none h-full overflow-y-auto dark:prose-invert">
                  {/* <ReactMarkdownMod components={{
                      a: ({ node, ...props }) => (
                        <a
                          {...props}
                          onClick={(e) => e.stopPropagation()} // stops card click
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-teal-500 hover:underline"
                        />
                      ),
                    }}> */}
                    <h2>{renderData().postTitle}</h2>
                    <ReactMarkdownMod_2>
                      {(parentComponent ==='THREAD' || parentComponent === 'PAGE') ? renderData().postBody.full : renderData().postBody.abbreviated
                  }</ReactMarkdownMod_2>
                </div>
                
                :
                  <div className="mt-1 text-sm font-normal break-word text-slate-800 dark:text-gray-300 whitespace-pre-wrap">
                    <p>
                      {
                        (parentComponent ==='THREAD' || parentComponent === 'PAGE') ?
                          formatSocialPostBody (renderData().postBody.full) : formatSocialPostBody (renderData().postBody.abbreviated)
                      }
                    </p>
                </div>
              }

                {/* Post body */}
                {/* <div className="mt-1 text-sm font-normal text-slate-800 dark:text-gray-300 whitespace-pre-wrap">
                  {
                  data.job_status === 'ACTIVE' 
                  ?
                  (parentComponent==='THREAD' ? formatSocialPostBody(data.social_post_comment_body) : formatSocialPostBody (data.social_post_body))
                  :
                  '[ Deleted ]'
                  }
                  
                </div> */}

                {/* post topics */}
                {data.topics && <div className="mt-6 text-sm text-slate-800 dark:text-gray-300 whitespace-pre-wrap flex gap-1">
                  {data.topics.map(t => <TagPill_3 key={t.uuid} href={`/feed/topics/${t.topic_name_en}`} caption={t.topic_name_en}/>)}
                  </div>
                  }
                {/* Post image(s) */}
                {data.files && <div className="my-4 text-sm text-slate-800 dark:text-gray-300 whitespace-pre-wrap">
                  {data.files?.map(f => {
                      return <img 
                        className={'rounded-lg max-h-[500px]'}
                        key={f.file_uuid}
                        src={`/assets/social/post_${parentComponent === 'THREAD' ? data.social_post_comment_uuid : data.social_post_uuid}/${f.file_name}`}
                        />
                  })}

                </div>}
              </div>

              {/* Optional tags or location */}
              {data.entity_location && (
                <div className="mt-2 text-xs text-slate-500 dark:text-slate-400">
                  {data.entity_location}
                </div>
              )}






    {/* {user.user_is_root && 
    <div className="mt-8">
            <BorderedFrameBox
            bgColor={'dark:bg-slate-800'}
                      borderColor="border-teal-400"
                        title={'ROOT'} 
                        body={  <TrashButton disabled={false} caption={'ROOT DELETE'} onClick={handleRootDelete} deleteConfirmation={rootDeleteConfirmation}/>}
                        />
            </div>
          } */}









    
    {/* ADMIN / MOD SECTION */}
              {
        user?.user_roles.role === 'ROOT' && 
          <div className="mt-2 flex gap-2 text-xs text-slate-500 dark:text-slate-400">
        <div className="flex gap-1 items-center rounded-2xl">
          

          <select id="status_change" name="status_change" className="py-4 px-4 rounded-lg bg-slate-100 dark:bg-slate-800" defaultValue={''}>
        {/* <option value={data.job_status} selected>{data.job_status}</option> */}
      <option value="" disabled> Status: {humanizeString(data.job_status || data.talent_status)}</option>    
      <option onClick={(e)=>{handleRootStatusChange(e, 'PENDING_REVIEW');}} value="PENDING_REVIEW">PENDING_REVIEW</option>
        <option onClick={(e)=>{handleRootStatusChange(e, 'ACTIVE')}} value="ACTIVE">ACTIVE</option>
        <option onClick={(e)=>{handleRootStatusChange(e, 'FLAGGED')}} value="FLAGGED">FLAGGED</option>
        <option onClick={(e)=>{handleRootStatusChange(e, 'REJECTED')}} value="REJECTED">REJECTED</option>
        <option onClick={(e)=>{handleRootStatusChange(e, 'ARCHIVED')}} value="ARCHIVED">ARCHIVED</option>
      </select>
            {/* <ConfirmOrCancelButton caption={'Approve Post'} disabled={false} onClick={e=>handleRootDelete(e)} deleteConfirmation={rootDeleteConfirmation}/> */}

        {/* <ArrowUpButton disabled={data.job_status === 'ARCHIVED'} onClick={e=>handlePostUpvote(e)} caption={data.reactions_count} reacted={data.reacted_by_me}/> */}
                <TrashButton disabled={false} onClick={e=>handleRootDelete(e)} deleteConfirmation={rootDeleteConfirmation}/>
        </div>
        </div>
        }




      <div className="mt-2 flex gap-2 text-xs text-slate-500 dark:text-slate-400">


        


    {
      /* -------------------------------
        if user is root 
        AND 
        if post doesn't belong to user AND location is not post thread
        AND
        post / comment is not deleted
      ---------------------------------*/
      
      //   (user?.user_is_root === true || 
      //   (user?.user_uuid === data.social_post_actor_uuid && parentComponent !== 'THREAD') 
      // ) && data.is_archived === false 
      data.job_status === 'ACTIVE'
      ? (
      <>

        <div className="flex flex-row w-full justify-between">
      {/* if user is owner of comment or post, show trash button */}
      <div className="flex flex-row gap-1">
      {/* <ArrowUpButton disabled={data.job_status === 'ARCHIVED'} onClick={e=>data.reacted_by_me ? handleDeleteUpvote(e) : handlePostUpvote(e)} caption={data.reactions_count} reacted={data.reacted_by_me}/> */}




        {cardIsComment === false && <CopyUrlButton disabled={(data.job_status === 'ARCHIVED' || data.talent_status === 'ARCHIVED')} 
          onClick={e=>{
          navigator.clipboard.writeText(`https://talnet.co/${getRecordData(parentModule).module}/${getRecordData(parentModule).url}`); e.stopPropagation(); setSuccess({message: 'Url copied'})}} reacted={data.reacted_by_me}/>
          }

        {/* <MultipurposeOvalButton onClick={e=>{e.stopPropagation();callback({setShareModalOpen:true, post:data})}} purpose={'share'}/> */}

        {parentComponent !== 'THREAD' && parentComponent !== 'PAGE' && <OpenUrlButton onClick={(e)=>e.stopPropagation()} disabled={false} url={`/${getRecordData(parentModule).module}/${getRecordData(parentModule).url}`}/>}


                  {/* <MultipurposeOvalButton onClick={(e)=>{e.stopPropagation();state.setShareModalOpen(true)}} purpose={'share'}/> */}
          </div>
          
          <div>
        {
        ( data.social_post_user_uuid ? user?.user_uuid === data.social_post_user_uuid : user?.user_uuid === data.social_post_comment_user_uuid)
          
          &&
          <TrashButton disabled={data.job_status === 'ARCHIVED'} onClick={e=>handleDelete(e)} deleteConfirmation={deleteConfirmation}/>
      }
      </div>
      </div>
      </>
      )

      /*-----------------------------------
        available to everyone (no sign in needed)
      -------------------------------------*/
        : parentComponent !== 'THREAD' &&  
        (   <>

        {/* <ArrowUpButton disabled={data.job_status === 'ARCHIVED'} onClick={e=>data.reacted_by_me ? handleDeleteUpvote(e) : handlePostUpvote(e)} caption={data.reactions_count} reacted={data.reacted_by_me}/> */}
          <CopyUrlButton disabled={(data.job_status === 'ARCHIVED' || data.talent_status === 'ARCHIVED')} 
        onClick={e=>{
        navigator.clipboard.writeText(`https://talnet.co/${getRecordData(parentModule).module}/${getRecordData(parentModule).url}`); e.stopPropagation(); setSuccess({message: 'Url copied'})}} reacted={data.reacted_by_me}/>
        <OpenUrlButton onClick={(e)=>e.stopPropagation()} disabled={false} url={`/${getRecordData(parentModule).module}/${getRecordData(parentModule).url}`}/>
      </>
    )
    }
        </div>     
              {/* maybe reactions bar? */}
              {/* <div className="mt-2 flex gap-6 text-xs text-slate-500 dark:text-slate-400">
                <span></span>
                <span></span>
                <span></span>
              </div> */}
            </div>
          </div>
    </div>



  );

};

export default SocialAssetSmallCard;

